"use strict";

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.join");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.string.split");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.buildQueryString = exports.removeChildren = void 0;

var removeChildren = function removeChildren(element) {
  while (element.firstChild) {
    element.firstChild.remove();
  }
};

exports.removeChildren = removeChildren;

var snakeCase = function snakeCase(word) {
  return word.split(/(?=[A-Z])/g).map(function (w) {
    return w.toLowerCase();
  }).join("_");
};

var buildQueryString = function buildQueryString(params) {
  if (!Object.keys(params) || Object.keys(params).length === 0) return "";
  return Object.keys(params).reduce(function (queryString, key) {
    var newParam = "".concat(snakeCase(key), "=").concat(params[key]);

    if (typeof params[key] !== "string") {
      newParam = Object.keys(params[key]).reduce(function (objectParams, attribute, currentIndex) {
        var objectParam = "".concat(snakeCase(key), "[").concat(snakeCase(attribute), "]=").concat(encodeURIComponent(params[key][attribute]));

        if (currentIndex === 0) {
          return objectParam;
        }

        return "".concat(objectParams, "&").concat(objectParam);
      }, "");
    }

    if (queryString !== "?") {
      newParam = "&".concat(newParam);
    }

    return "".concat(queryString).concat(newParam);
  }, "?");
};

exports.buildQueryString = buildQueryString;